import {AppleLogo, PlayStore} from '@jobseeker/lotus/icons';
import {JobfeedQr} from '@jobseeker/lotus/images';
import {
  Box,
  Typography as Typo,
  styled,
  TypographyProps,
  Card,
} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {getOldLink} from '@jobseeker/lotus/utils';
import {openUrl} from '@jobseeker/common-core/utils/common';

const Typography = styled(Typo)<TypographyProps>(({}) => ({
  display: 'flex',
  alignItems: 'center',
}));

const DownloadAppOnJobFeed = ({
  sendEvent = (eventCatogory: string, eventName: string, action: string) => {},
}) => {
  return (
    <>
      <Card
        data-testid="download_app_qr_on_jobfeed"
        sx={{
          borderRadius: 4,
          mt: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          gap: 1.5,
          px: 2,
          py: 1.5,
          '@media (max-width: 900px)': {
            display: 'none',
          },
        }}
      >
        <Box
          width={'100%'}
          display={'flex'}
          justifyContent={'flex-start'}
          alignItems={'center'}
        >
          <Box
            display={'flex'}
            borderRadius={2}
            mr={1}
            p={0.5}
            border={'1px solid rgba(126, 126, 126, 0.20)'}
          >
            <Image
              src={JobfeedQr}
              width={44}
              height={44}
              alt="appPromoQr"
              style={{borderRadius: 4}}
            />
          </Box>

          <Box
            display={'flex'}
            py={0.25}
            flexDirection={'column'}
            justifyContent={'flex-start'}
          >
            <Typography
              variant="caption"
              fontWeight={500}
              color={'text.secondary'}
              width={'131px'}
              lineHeight={'12px'}
            >
              IIMJOBS IS BETTER ON APP!
            </Typography>
            <Typography
              variant="subtitle3"
              color={'text.primary'}
              lineHeight={'16px'}
              mt={0.125}
            >
              Scan the QR to install
            </Typography>
            <Box
              display={'flex'}
              justifyContent={'flex-start'}
              alignItems={'center'}
              gap={0.875}
              mt={0.375}
            >
              <Box
                sx={{cursor: 'pointer'}}
                onClick={() => {
                  sendEvent('App_Promotion', 'DownloadAppQR2Desktop', 'Click');
                  openUrl(
                    getOldLink(
                      'https://apps.apple.com/in/app/iimjobs-management-job-search/id538258273'
                    ),
                    '_blank'
                  );
                }}
                display={'flex'}
              >
                <Image src={AppleLogo} alt={''} width={16} height={16} />
              </Box>
              <Box
                sx={{cursor: 'pointer'}}
                onClick={() => {
                  sendEvent('App_Promotion', 'DownloadAppQR2Desktop', 'Click');
                  openUrl(
                    getOldLink(
                      'https://play.google.com/store/apps/details?id=com.org.iimjobs'
                    ),
                    '_blank'
                  );
                }}
                display={'flex'}
              >
                <Image src={PlayStore} alt={''} width={15} height={15} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Card>
    </>
  );
};

export default DownloadAppOnJobFeed;
